import React, { FC } from 'react';
import { makeStyles } from 'tss-react/mui';

import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import CircularProgress from '@mui/material/CircularProgress';

import { transactionsTypes } from 'companion-app-components/flux/transactions';

import { styles } from './styles';

const useStyles = makeStyles()(styles as Record<string, any>);

interface CreateNewRecurringDialogProps {
  showNewRecurrenceProgress: boolean;
  uiState: Record<string, any>;
  txForm: transactionsTypes.CashFlowTransaction;
}

const CreateNewRecurringDialog: FC<CreateNewRecurringDialogProps> = ({
  showNewRecurrenceProgress,
  uiState,
  txForm,
}) => {
  
  const { classes } = useStyles();

  return (
    <Dialog 
      open={Boolean(showNewRecurrenceProgress && uiState.newScheduledTransactionClientId)}
    >
      <DialogContent
        className={classes.dialogContent}
      >
        <Typography variant="h5">
          Creating New Recurring
        </Typography>
        <Paper className={classes.paper}>
          <Avatar sx={{ m: 2.5 }}>
            {txForm.payee ? txForm.payee[0].toUpperCase() : '*'}
          </Avatar>
          <Typography variant="h6">
            {txForm.payee}
          </Typography>
        </Paper>
        <CircularProgress />
      </DialogContent>
    </Dialog>
  );
};

export default CreateNewRecurringDialog;
